let x_pi=3.14159265358979324 * 3000.0 / 180.0;
// GCJ02 --> BD09
function transformGCJ2ToBD(point){
    let newPoint={lng:0,lat:0};
    let x=point.lng;
    let y=point.lat;
    let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
    let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
    newPoint.lng = z * Math.cos(theta) + 0.0065;
    newPoint.lat = z * Math.sin(theta) + 0.006;
    return newPoint;
}
// GCJ02 --> WGS84
let PI = 3.14159265358979324;
function transformGCJ2ToWGS({lng,lat}) {
    let d = delta(lat, lng)
    return {
      'lat': lat - d.lat,
      'lng': lng - d.lon
    }
  }

  function delta(lat, lon) {
    let a = 6378245.0 //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
    let ee = 0.00669342162296594323 //  ee: 椭球的偏心率。
    let dLat = transformLat(lon - 105.0, lat - 35.0)
    let dLon = transformLon(lon - 105.0, lat - 35.0)
    let radLat = lat / 180.0 * PI
    let magic = Math.sin(radLat)
    magic = 1 - ee * magic * magic
    let sqrtMagic = Math.sqrt(magic)
    dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * PI)
    dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * PI)
    return {
      'lat': dLat,
      'lon': dLon
    }
  }
  function transformLat(x, y) {
    let ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x))
    ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0
    ret += (20.0 * Math.sin(y * PI) + 40.0 * Math.sin(y / 3.0 * PI)) * 2.0 / 3.0
    ret += (160.0 * Math.sin(y / 12.0 * PI) + 320 * Math.sin(y * PI / 30.0)) * 2.0 / 3.0
    return ret
  }
  function transformLon(x, y) {
    let ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x))
    ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0
    ret += (20.0 * Math.sin(x * PI) + 40.0 * Math.sin(x / 3.0 * PI)) * 2.0 / 3.0
    ret += (150.0 * Math.sin(x / 12.0 * PI) + 300.0 * Math.sin(x / 30.0 * PI)) * 2.0 / 3.0
    return ret
  }

function transform(point, mapType){
    let result = null;
    switch(mapType){
        case 'bmap':
            result = transformGCJ2ToBD(point);
            break;
        case 'olmap':
        case 'tmap':
        case 'gmap':
            result = transformGCJ2ToWGS(point);
            break;
        default:
            result=point;
            break;
    }
    return result;
}

export {
    transform,
    transformGCJ2ToBD,
    transformGCJ2ToWGS
}